import { Box, Button, Divider, IconButton, InputAdornment, LinearProgress, MenuItem, Pagination, Popover, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material"
import { TEXT_TITLE_COLOR } from "../../constants/colors";
import SearchIcon from '@mui/icons-material/Search';
import useFormDriverRegisterController from "./controller";
import { FormRiderModel } from "../../models/formRider";
import { numberFormat } from "../../utils/nunberFormat";
import { FETCH_MORE_DATA_AMOUNT } from "../../config-global";
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import TableSearchNotFound from "../../components/tableSearchNotFound";
import { useTranslation } from "react-i18next";
import DeleteIcon from '@mui/icons-material/Delete'
import ConfirmDialog from "../../components/ConfirmDialog";
import FormRiderView from "./form";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import { convertDateStringToNormalDateTime } from "../../utils/convertDateFormat";
import StatusConfirmShip from "./components/statusConfirm";
import TabPanelComponents from "./components/tabPanel";

const DriverFormRegisterView = () => {
    const controller = useFormDriverRegisterController()
    const { t } = useTranslation('global');

    return (
        <>
            {
                controller.openFormRiderRegister ? <FormRiderView onClose={controller.handleCloseFormRiderRegister} dataFormRider={controller.selectedFormRider} onFetchData={controller.handleFetchData} />
                    : <>
                        {
                            controller.loadingData ?
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <LoadingAnimatedIcon />
                                </Box> : <>
                                    <Box sx={{ display: 'flex' }} >
                                        <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight='bold'>{t("registerFormRider_page.Register Form Driver")}</Typography>
                                        <Box sx={{ ml: 5 }}>
                                            <TextField
                                                fullWidth
                                                placeholder={`${t("registerFormRider_page.Search by name")}`}
                                                value={controller.searchValue}
                                                onChange={controller.handleSearch}
                                                sx={{ maxWidth: 250 }}
                                                size="small"
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Box>
                                    </Box>
                                    <Box sx={{ mt: 4 }}>
                                        <TabPanelComponents value={controller.tabFormRider} onChange={controller.handleTabFormRider} />
                                    </Box>
                                    <Box mt={1}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead sx={{ background: "#F4F6F8" }}>
                                                    <TableRow>
                                                        {
                                                            controller.TableHeaderValue?.map((item: string, idx: number) => <TableCell key={idx}>{item}</TableCell>)
                                                        }
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        controller.rowFormRider.map((row: FormRiderModel, index: number) => {
                                                            const { id, firstName, lastName, gender, phoneNumber, homeAddress, dateOfBirth, createdAt, confirm } = row;
                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                        {numberFormat(index + 1 + 10 * (controller.currentFormPage - 1))}
                                                                    </TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{firstName}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{lastName}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{phoneNumber}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{gender}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{dateOfBirth}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{homeAddress}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>{convertDateStringToNormalDateTime(createdAt)}</TableCell>
                                                                    <TableCell sx={{ borderBottom: 'none' }}>
                                                                        <StatusConfirmShip status={confirm} />
                                                                    </TableCell>
                                                                    <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                        <IconButton
                                                                            size="large"
                                                                            color="inherit"
                                                                            onClick={(e: any) => controller.handleOpenMenuFormRider(e, id)}
                                                                        >
                                                                            <MoreHorizIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                                {controller.isSearchNotFound && (
                                                    <TableSearchNotFound
                                                        searchValue={controller.searchValue}
                                                        colSpan={controller.TableHeaderValue?.length}
                                                    />
                                                )}
                                            </Table>
                                        </TableContainer>
                                        <Divider />
                                        <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2 }}>
                                            <Pagination
                                                color="primary"
                                                page={controller.currentFormPage}
                                                onChange={controller.handleChangePage}
                                                count={controller.countFormPagination}
                                            />
                                        </Box>
                                    </Box>
                                    <Popover
                                        open={Boolean(controller.openMenu)}
                                        anchorEl={controller.openMenu}
                                        onClose={controller.handleCloseMenu}
                                        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        PaperProps={{
                                            sx: {
                                                p: 1,
                                                width: 140,
                                                '& .MuiMenuItem-root': {
                                                    px: 1,
                                                    typography: 'body2',
                                                    borderRadius: 0.75,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem onClick={controller.handleOpenFormRiderRegister}>
                                            &nbsp;&nbsp;
                                            {t('See Detail')}
                                        </MenuItem>
                                        <MenuItem onClick={() => controller.handleOpenDeleteForm()}>
                                            <DeleteIcon />
                                            &nbsp;&nbsp;
                                            {t("Delete")}
                                        </MenuItem>
                                    </Popover>
                                    <ConfirmDialog
                                        open={controller.openDeleteForm}
                                        title='Do you want to delete this Data ?'
                                        loading={controller.loadingDeleteButton}
                                        onCancel={controller.handleCloseDeleteForm}
                                        onConfirm={() => controller.handleDeleteFormRiderRegister()}
                                    />
                                </>
                        }

                    </>
            }
        </>
    )
}
export default DriverFormRegisterView